type PixelConfiguration = Record<string, Record<string, string>>;
type BrandId = string | number;

const PIXEL_IDS: PixelConfiguration = {
    "31": {
        channel36: "eeb2cbc9-f63f-45ae-aedc-67d7105ac70f",
        channel37: "eeb2cbc9-f63f-45ae-aedc-67d7105ac70f",
    },
    "32": {
        channel36: "eeb2cbc9-f63f-45ae-aedc-67d7105ac70f",
        channel37: "eeb2cbc9-f63f-45ae-aedc-67d7105ac70f",
    },
    "46": {
        channel538: "291cc34a-991f-4236-b34f-9be0b2a7f75a",
        channel539: "291cc34a-991f-4236-b34f-9be0b2a7f75a",
    },
    "47": {
        channel538: "291cc34a-991f-4236-b34f-9be0b2a7f75a",
        channel539: "291cc34a-991f-4236-b34f-9be0b2a7f75a",
    },
    "39": {
        channel516: "179275b7-a68d-489b-bb13-a623e4e72714",
        channel517: "179275b7-a68d-489b-bb13-a623e4e72714",
    }

};

export const snapchatPxl = (
    marketingSource: string,
    brandId: BrandId,
    isPageView = false,
    isLead = false,
    isPurchase = false
): void => {
    if (
        !marketingSource ||
        brandId === null ||
        brandId === undefined ||
        typeof window === "undefined" ||
        typeof document === "undefined"
    ) {
        return;
    }

    const normalizedBrandId = String(brandId);
    const normalizedSource = marketingSource.trim().toLowerCase();
    const pixelId = PIXEL_IDS[normalizedBrandId]?.[normalizedSource];

    if (!pixelId) {
        return;
    }

    const browserWindow = window as any;

    if (!browserWindow.snaptr) {
        const snaptr: any = function (...args: unknown[]) {
            if (snaptr.handleRequest) {
                snaptr.handleRequest(...args);
            } else {
                snaptr.queue.push(args);
            }
        };

        snaptr.queue = [];
        browserWindow.snaptr = snaptr;

        const script = document.createElement("script");
        script.async = true;
        script.src = "https://sc-static.net/scevent.min.js";
        document.head.appendChild(script);

        browserWindow.snaptr("init", pixelId, {});
    }

    // This must remain outside the initialization block.
    if (isPageView) {
        browserWindow.snaptr("track", "PAGE_VIEW");
    } else if (isLead) {
        browserWindow.snaptr("track", "SIGN_UP");
    } else if (isPurchase) {
        browserWindow.snaptr("track", "PURCHASE");
    }
};